// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const Checkbox: MarkdocTagRegistration = {
  tag: 'checkbox',
  component: 'Checkbox',
  attributes: {
    id: {type: String, required: true},
    title: {type: String, required: true, localizable: true},
    description: {type: String, required: false, localizable: true},
    checked: {type: Boolean, required: false},
    disabled: {type: Boolean, required: false},
  },
};
